module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-app"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading || !_vm.user
    }
  }), _vm._v(" "), (_vm.hasError) ? _c('server-error') : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.user && !_vm.hasError && !_vm.hasAccessError) ? [_c('div', [_c('sidebar', [_c('div', {
    staticClass: "logo",
    attrs: {
      "slot": "start"
    },
    slot: "start"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo.png",
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('menu-sidebar', {
    directives: [{
      name: "menu",
      rawName: "v-menu"
    }],
    attrs: {
      "slot": "content"
    },
    slot: "content"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-app__content"
  }, [_c('header', {
    staticClass: "l-app__topbar top-bar"
  }, [_c('nav', {
    staticClass: "c-navbar c-navbar--light"
  }, [_c('div', {
    staticClass: "c-navbar__left"
  }, [_c('a', {
    directives: [{
      name: "toggle",
      rawName: "v-toggle:sidebar",
      arg: "sidebar"
    }],
    staticClass: "c-navbar__item u-hiddenUp@md",
    attrs: {
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "i-menu i-menu--light"
  })])]), _vm._v(" "), _c('menu-top-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-app__body"
  }, [_c('main', {
    staticClass: "l-app__main"
  }, [_c('breadcrumb', {
    ref: "breadcrumb"
  }), _vm._v(" "), _c('router-view')], 1)])])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c0c666","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Layout.vue
// module id = 3256
// module chunks = 0